





















import { Modal } from 'bootstrap';
import {Component, Vue} from 'vue-property-decorator';

@Component
export default class Dialog extends Vue {
    private modal: Modal;

    public show(): void {
        this.modal.show();
    }

    public hide(): void {
        this.modal.hide();
    }

    protected mounted(): void {
        this.modal = new Modal(this.$refs.modal as HTMLElement);
    }
}
